import { render, staticRenderFns } from "./ExpedienteEntryApelacion.vue?vue&type=template&id=7e8c746f&"
import script from "./ExpedienteEntryApelacion.vue?vue&type=script&lang=js&"
export * from "./ExpedienteEntryApelacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports